import * as React from "react"
import { IntegrationCard } from "./IntegrationCard"
import type {
  Connection,
  IntegrationCatalogItem,
} from "@/features/integrations/api/types"

type Props = {
  items: IntegrationCatalogItem[]
  connectionsById: Record<string, Connection>
  onSelect: (id: string) => void
}

export function IntegrationGrid({ items, connectionsById, onSelect }: Props) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {items.map((item) => (
        <IntegrationCard
          key={item.id}
          item={item}
          connection={connectionsById[item.id]}
          onClick={onSelect}
        />
      ))}
    </div>
  )
}
